// @ts-strict-ignore
import React, { Dispatch, SetStateAction, useContext, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { Button, Dialog, Illustration } from '@node-space/ui-components'
import { ExternalLink } from 'components/ExternalLink/ExternalLink'
import { WalletSheet } from 'pages/Wallets/components/Sheet/WalletSheet'
import { WalletActionContext } from 'pages/Wallets/context/WalletSheetProvider'
import { Contact } from 'types/contacts'
import { ActionIds } from 'types/types'

interface ChannelCreateDialogProps {
  contact: Contact
  isDialogOpen: boolean
  setIsDialogOpen: Dispatch<SetStateAction<boolean>>
}

export const ChannelCreateDialog = ({
  contact,
  isDialogOpen,
  setIsDialogOpen,
}: ChannelCreateDialogProps) => {
  const { t } = useTranslation()
  const [, setWalletAction] = useContext(WalletActionContext)
  const [isSheetOpen, setIsSheetOpen] = useState(false)

  const handleOpenChannelPaymentSheet = () => {
    setWalletAction({
      actionId: ActionIds?.CHANNEL_PAYMENT,
      header: t('payments.channelPayments.contactStepHeader'),
      onClose: () => {
        setIsSheetOpen(false)
      },
      meta: {
        onPaymentChannelSuccess: () => setIsDialogOpen(false),
      },
    })
    setIsSheetOpen(true)
  }

  return (
    <>
      <Dialog
        open={isDialogOpen}
        onClose={() => setIsDialogOpen(false)}
        title={t('contacts.newAddressNeeded', { name: contact?.name })}
        Illustration={<Illustration name="Warning" />}
        ActionButtons={[
          <Button key="create" onClick={handleOpenChannelPaymentSheet}>
            {t('payments.channels.createChannel')}
          </Button>,
        ]}
      >
        <p className="text-body-regular text-foreground-prominent text-center">
          {t('contacts.newAddressNeededDescription', { name: contact?.name })}{' '}
          <ExternalLink href={process.env.ASSIGN_CONTACT_URL}>
            {t('contacts.readMore')}
          </ExternalLink>
        </p>
      </Dialog>
      <WalletSheet isSheetOpen={isSheetOpen} />
    </>
  )
}
